<svelte:options accessors />

<script>
	export let info = 'Info';
</script>

<div class="hover-component">Info Box</div>

<style>
	.hover-component {
		position: fixed;
		top: 0;
		left: 0;
		width: calc((100vw - 700px) / 2); /* Calculate the width */
		background-color: #f0f0f0;
		padding: 10px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
		transition: transform 0.3s ease-in-out;
		transform: translateY(calc(-100% + 50px));
		overflow: auto; /* Handle overflow for smaller screens */
	}

	.hover-component:hover {
		transform: translateY(0);
	}
</style>
